import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    selector: 'installation-groundlevel',
    templateUrl: './ground-level.component.html',
    standalone: false
})
export class InstallationGroundLevelPluginComponent {
  public levelType: any;
  public config: any;
  public editRoute = ['installation', 'groundlevel', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.levelType = this.config.LevelType;
  }
}
PluginComponent.plugins['installationgroundlevel'] = InstallationGroundLevelPluginComponent;
